// Supabase responses across postgrest/auth/storage/functions all share the
// `{ data, error }` envelope with an XOR between them on success. Every
// service in this folder used to spell the same `if (error) { throw error }`
// branch by hand — this helper collapses that to a single call.
//
// Contract is silent-throw: the helper never calls `logError`. Higher-level
// boundaries (Vue composables, top-of-function try/catch in services that
// orchestrate multiple operations) already decide when to report to Sentry;
// logging here would double-log them.
export function throwIfSupabaseError<R extends { error: object | null }>(
    response: R,
): asserts response is Extract<R, { error: null }> {
    if (response.error !== null) {
        throw response.error;
    }
}
